export const USER_STORE_KEY = "rxUser";

export const IMAGE_REMOVED = 'REMOVED';

export const ONLINE_CUSTOMER_USER_TYPE = 4;

export const PAYMODE_CASH = "CASH";

